import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export interface Props {
  editor?: object;
  enabled?: boolean;
  redirectUrl?: string;
}

const propsSchema: PropsSchemaList = [
  {
    key: 'enabled',
    label: 'Enabled',
    type: types.BOOLEAN,
  },
  {
    key: 'redirectUrl',
    label: 'Redirect URL',
    type: types.TEXT,
  },
];

const defaultProps: Props = {
  enabled: false,
  redirectUrl: 'https://www.ff.com/us/'
};

export default {
  title: 'Redirect',
  id: 'Redirect',
  propsSchema,
  defaultProps,
}
